import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useState } from 'react';

const ModalText = props => {
    const [open, setOpen] = useState(false);

    const doSetOpen = value => {
        if (props.setOpen === undefined) {
            setOpen(value)
        } else {
            props.setOpen(value)
        }
    }

    const doGetOpen = () => {
        if (props.open === undefined) {
            return open
        }
        return props.open
    }

    return (
            <span>
                <span className='link' onClick={() => {doSetOpen(true)}}>{props.trigger}</span>
                <Dialog
                    onClose={() => doSetOpen(false)}
                    open={props.open === undefined ? open : props.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {props.text}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {props.children}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => doSetOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>
            </span>
        )
}

export default ModalText;